import { DirectiveCreateButton } from 'components/directive/directiveSteppedGuide/DirectiveCreateButton'
import { DirectiveGuideStepVisual } from 'components/directive/directiveSteppedGuide/DirectiveGuideStepVisual'
import { STitleRow } from 'components/directive/directiveSteppedGuide/styled'
import { getDirectiveSpec } from 'components/directive/utils/directiveSpecs'
import { DirectiveType } from 'components/directive/utils/types'
import { Step, StepsGuideList } from 'components/stepsGuide/StepsGuide'
import { Title, Title_h4_default } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import React, { useMemo } from 'react'
import { numberRange } from 'utils/general'
import { useWindowSize } from 'utils/hooks'

interface Props {
  type: DirectiveType
  isTutorial?: boolean
}

export function DirectiveSteppedGuide(props: Props) {
  const { landingPageNamespace } = getDirectiveSpec(props.type)
  const { t } = useTranslation(landingPageNamespace)
  const { isDesktop } = useWindowSize()

  const visualHeight = useMemo(() => {
    if (!isDesktop) return '2.5rem'

    if (props.isTutorial) return '3.5rem'

    return undefined
  }, [props.isTutorial, isDesktop])

  const steps: Step[] = useMemo(() => {
    const spec = getDirectiveSpec(props.type)

    return numberRange(3).map((i) => {
      return {
        title: t(`${landingPageNamespace}.steps_guide.step_${i}.title`),
        desc: t(`${landingPageNamespace}.steps_guide.step_${i}.desc`),
        visual: (
          <DirectiveGuideStepVisual isTutorial={props.isTutorial} step={spec.guideSteps[i]} />
        ),
      }
    })
  }, [props.type, props.isTutorial, t, landingPageNamespace])

  return (
    <div>
      {!props.isTutorial && (
        <STitleRow>
          <Title variant={Title_h4_default} as="h2">
            {t(`${landingPageNamespace}.steps_guide.title`)}
          </Title>

          {!props.isTutorial && (
            <DirectiveCreateButton type={props.type} className="desktop-only" />
          )}
        </STitleRow>
      )}

      <StepsGuideList steps={steps} singleLine visualHeight={visualHeight} />

      {!props.isTutorial && <DirectiveCreateButton type={props.type} className="mobile-only" />}
    </div>
  )
}
